import { createFormatForDescription as cffd } from '../createFormatForDescription'
import { Explanation, explain } from '../explain/Explanation'
import OfferCancelInstructions from '../types/instructions/OfferCancelInstructions'
import TransactionType from '../types/TransactionType'

/**
 * An annotation for OfferCancel transactions.
 *
 * @property type - The transaction type.
 * @property offerSequence - An explanation of the offerSequence.
 */
export interface OfferCancelAnnotation {
  readonly type: TransactionType.OfferCancel
  readonly offerSequence: Explanation<number>
}

/**
 * Takes a transaction object and returns an annotated transaction object.
 * The returned object contains explanations about the various transaction features.
 *
 * @param transactionInstructions - The input transaction.
 * @returns An annotated transaction object detailing the various transaction features.
 */
export function annotate(
  transactionInstructions: OfferCancelInstructions,
): OfferCancelAnnotation {
  const offerSequence = explain(
    transactionInstructions.OfferSequence,
    `Cancel the OfferCreate transaction with sequence number ${cffd(
      transactionInstructions.OfferSequence.toString(),
      'offerSequence',
    )}.`,
  )
  return {
    type: TransactionType.OfferCancel,
    offerSequence,
  }
}
